import { forwardRef } from "react";
import { Box, BoxProps } from "@mui/material";
import { styled, Palette } from '@mui/material/styles'
import CssFilterConverter from "css-filter-converter";
import { get } from "lodash";

export type WithColorCode = {
  targetColor?: string; // Hex Code
};

export type WithThemeColor = {
  themeColor?: Palette | string;
}

export type WithFilterColor = WithColorCode | WithThemeColor;

export type Props = Omit<BoxProps<"img">, "component"> & WithFilterColor;

const Component = styled(
  Box,
  {}
)<any>(({ theme: { palette }, targetColor, themeColor }) => ({
  filter:
    themeColor || targetColor
      ? (CssFilterConverter.hexToFilter(
          get(palette, `${themeColor}.main`, targetColor) as string
        )?.color as unknown as string | undefined)
      : undefined,
}));

const Image = forwardRef((props: Props, ref: any) => (
  <Component ref={ref} component="img" {...props} />
));

export default Image;
